import http from '../../js/http';

// Счётчик актуальности запроса сводки (тот же приём, что в EnpsMonthlyTrendChart /
// EnpsRatingsPanel): при быстром переключении отдела или периода поздний ответ не должен
// перезаписывать данные более свежего запроса — применяется только последний.
let loadSeq = 0;

export default {
    // department заполняется только администратором (переключатель отделов); для остальных
    // бэкенд игнорирует параметр и сам скоупит по отделу вызывающего.
    FETCH_SUMMARY({ commit }, { period, department = '' }) {
        const seq = ++loadSeq;

        commit('SET_LOADING', true);
        commit('SET_LOAD_ERROR', false);

        return http
            .get('/enps/dashboard', { params: { period, department } })
            .then(({ data }) => {
                if (seq === loadSeq) {
                    commit('SET_SUMMARY', data);
                }
            })
            .catch(() => {
                // Нулевые заглушки в state на месте данных читались бы как валидные цифры —
                // страница по этому флагу показывает честное «не удалось загрузить».
                if (seq === loadSeq) {
                    commit('SET_LOAD_ERROR', true);
                }
            })
            .finally(() => {
                if (seq === loadSeq) {
                    commit('SET_LOADING', false);
                }
            });
    },
};
